import styled from 'styled-components'
import { COLORS } from '../../constants'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  padding: 0 0 0 1rem;
  margin-left: 1rem;
  width: 30%;
  height: 100%;
  background-color: ${COLORS.white};
  overflow: hidden;
`

export const DropdownsContainer = styled.div`
  display: flex;
  margin-bottom: 1.5rem;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 10px;
  padding: 0;
  box-sizing: border-box;

  & > * {
    box-sizing: border-box;
    font-weight: bold;
  }
`

export const FixedContainer = styled.div`
  position: sticky;
  padding-right: 20px;
  margin: 0 auto;
  flex: 1;
  background-color: ${COLORS.white};
  z-index: 10;
`

export const SelectionContainer = styled.div`
  z-index: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  overflow-y: auto;
  min-height: 50vh;
  max-height: calc(100vh - 350px);
  width: 100%;
  box-sizing: border-box;
  padding-bottom: 80px;
  padding-right: 20px;
`

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background-color: ${COLORS.gray};
`

export const NoResults = styled.h3`
  text-align: center;
  line-height: 1.5;
  margin-top: 1rem;
  font-size: 1.5rem;
  color: ${COLORS.darkGray};
  overflow: hidden;
`
export const LoadMoreContainer = styled.div`
  margin: 2rem auto;
  display: flex;
  justify-content: center;
`

export const LoadMoreButton = styled.button`
  color: ${COLORS.white};
  font-size: 1.2rem;
  padding: 0.8rem 1rem;
  background-color: ${COLORS.primary};
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  &:hover {
    background-color: ${COLORS.tertiary};
  }
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  width: 100%;
  flex-grow: 1;
  background-color: ${COLORS.white};
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
  max-height: 100%;
`
